module.exports = __webpack_public_path__ + "img/premier-web__lighthouse_score.3b581f22.jpg";